var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3666 9.2081L10.7082 16.8664C9.77005 17.8046 8.49757 18.3317 7.17075 18.3317C5.84393 18.3317 4.57145 17.8046 3.63325 16.8664C2.69505 15.9282 2.16797 14.6558 2.16797 13.3289C2.16797 12.0021 2.69505 10.7296 3.63325 9.79144L11.2916 2.1331C11.9171 1.50763 12.7654 1.15625 13.6499 1.15625C14.5345 1.15625 15.3828 1.50763 16.0082 2.1331C16.6337 2.75857 16.9851 3.60689 16.9851 4.49144C16.9851 5.37598 16.6337 6.2243 16.0082 6.84977L8.34158 14.5081C8.02885 14.8208 7.60469 14.9965 7.16242 14.9965C6.72014 14.9965 6.29598 14.8208 5.98325 14.5081C5.67051 14.1954 5.49482 13.7712 5.49482 13.3289C5.49482 12.8867 5.67051 12.4625 5.98325 12.1498L13.0582 5.0831",
    stroke: "#00AE9B",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.1379110d8c5e6bbeba7d9a39485ac2cb.svg";
export { ForwardRef as ReactComponent };